<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad">
      <!--<template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.valuedatareported_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>-->
      <template slot="projectIdSearch">
        <el-select
          v-model="projectName"
          @change="searchProjectChange"
        >
          <el-option
            v-for="item in projectList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
<!--      <template slot="analyseSortSearch">-->
<!--        <el-select-->
<!--          v-model="analyseSortName"-->
<!--          clearable placeholder="请选择"-->
<!--          @change="searchAnalyseSortChange"-->
<!--        >-->
<!--          <el-option-->
<!--            v-for="item in analyseSortList"-->
<!--            :key="item"-->
<!--            :label="item.dictValue"-->
<!--            :value="item.dictKey"-->
<!--          ></el-option>-->
<!--        </el-select>-->
<!--      </template>-->
      <template slot="subjectIdSearch">
        <el-select
          v-model="subjectIdName"
          filterable=true
          clearable placeholder="请选择"
        >
          <el-option
            v-for="item in subjectIdList"
            :key="item"
            :label="item.analyseSubject"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="fileListForm" slot-scope="scope">
        <vUpload :max="5242880" :limit="10" :fileList.sync="form.fileList" :disabled="form.flag == 'view'"></vUpload>
      </template>
    </avue-crud>

  </basic-container>
</template>

<script>
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    getSubjectBySort,
    getPeriodList,
    //getLastEndTime,
    getSortBySubject
  } from "@/api/crmedical/value/valuedatareported";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import dayjs from 'dayjs'
  // import {getAttachByMainIdList} from "@/api/crmedical/attach/attach";
  // import {getDictionary} from "@/api/system/dict";
  import { Base64 } from 'js-base64';
  import settings from '@/config/vd-settings';
  import { getToken } from '@/util/auth';
  import vUpload from "@/views/components/v-upload";

  export default {
    components: {
      vUpload
    },
    data() {
      return {
        projectName: '',
        analyseSortName: '',
        subjectIdName: '',
        form: {
          flag: '',
          subjectFlag:'',
          attachList: [],
          periodFlag:'',
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        reWrite: false,
        tempProjectId: '',
        projectList: [],
        analyseSortList: [],
        subjectIdList: [],
        attachIdList: [],
        fileDisabled: false,
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          indexLabel: '序号',
          index: true,
          viewBtn: true,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 6,
          align: 'center',
          column: [

            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              editDisabled: true,
              span: 8,
              searchslot: true,
              searchClearable: false,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id'
              },
              rules: [
                {
                  required: true,
                  message: "请选择项目",
                  trigger: "change"
                }
              ]
            },
            {
              label: "周期",
              prop: "period",
              type: 'select',
              search: true,
              span: 8,
              dicData: [],
              props: {
                label: 'name',
                value: 'value'
              },
              rules: [
                {
                  required: true,
                  message: "请选择周期",
                  trigger: "change"
                }
              ]
            },

            {
              label: "科目",
              prop: "subjectName",
              span: 8,
              editDisplay: false,
              viewDisplay: false,
              addDisplay: false,

            },

            /* {
               label: "科目",
               prop: "subjectNameDetail",
               hide: true,
               span: 8,
               addDisplay: false,
               editDisplay: false,
             },*/
            {
              label: '科目',
              prop: 'subjectId',
              type: 'tree',
              searchslot: true,
              span: 8,
              hide: true,
              search: true,
              //dataType: 'number',
              dicData: [],
              props: {
                label: 'analyseSubject',
                value: 'id',
              },
              rules: [
                {
                  required: true,
                  message: '请选择科目',
                  trigger: 'change',
                },
              ],

            },
            {
              label: "类别",
              prop: "analyseSort",
              type: "select",
              search: false,
              //searchslot: true,
              span: 8,
              dataType: 'number',
              editDisabled:true,
              addDisabled:true,
              dicUrl: '/api/blade-system/dict/dictionary?code=vaule_analyse_sort',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              rules: [
                {
                  required: true,
                  message: "请选择类别",
                  trigger: "change"
                }
              ]
            },
            {
              label: "核算月份",
              prop: "accountingMonth",
              type: "month",
              format: 'yyyy-MM',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              span: 8,
              rules: [
                {
                  required: true,
                  message: "请选择核算月份",
                  trigger: "change"
                }
              ]
            },
            // {
            //   label: "开始时间",
            //   prop: "startTime",
            //   type: "month",
            //   format: 'yyyy-MM-dd',
            //   valueFormat: 'yyyy-MM-dd 00:00:00',
            //   span: 8,
            //   value: "1994",
            //   rules: [
            //     {
            //       required: true,
            //       message: "请输入开始时间",
            //       trigger: "change"
            //     }
            //   ]
            // },
            // {
            //   label: "结束时间",
            //   prop: "endTime",
            //   type: "date",
            //   span: 8,
            //   format: 'yyyy-MM-dd',
            //   valueFormat: 'yyyy-MM-dd 00:00:00',
            //   rules: [
            //     {
            //       required: true,
            //       message: "请输入结束时间",
            //       trigger: "change"
            //     },
            //     {
            //       validator: (rule, value, callback) => {
            //         var dateStart = Date.parse(this.form.startTime);
            //         var dateEnd = Date.parse(value);
            //         if (dateStart >= dateEnd) {
            //           callback(new Error('结束时间必须大于开始时间！'));
            //         } else {
            //           callback();
            //         }
            //       },
            //       trigger: 'change',
            //     },
            //   ]
            // },


            {
              label: "呈报金额",
              prop: "money",
              span: 8,
              maxlength: 11,
              rules: [
                {
                  required: true,
                  message: "请输入呈报金额",
                  trigger: "change"
                },
                {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '请输入8位以内最多2位小数金额'},
              ]
            },
            {
              label: "填报人",
              prop: "name",
              span: 8,
              editDisplay: false,
              viewDisplay: false,
              addDisplay: false,

            },
            {
              label: "填报时间",
              prop: "createTime",
              span: 8,
              editDisplay: false,
              viewDisplay: false,
              addDisplay: false,

            },
            {
              label: '电子附件',
              span: 24,
              hide: true,
              formslot: true,
              prop: 'fileList',
            }
          ]
        },
        data: [],
        headers:{},
        viewFlag: false,
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.valuedatareported_add, false),
          viewBtn: this.vaildData(this.permission.valuedatareported_view, false),
          delBtn: this.vaildData(this.permission.valuedatareported_delete, false),
          editBtn: this.vaildData(this.permission.valuedatareported_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    watch: {
      'form.projectId'(flag) {

        if (this.form.flag === 'add') {
          this.form.analyseSort = '';
          this.form.subjectId = '';
          this.form.accountingMonth='';
          const column3 = this.findObject(this.option.column, 'subjectId');
          column3.dicData = ['']
          // console.log(column3);
        }
        //this.form.analyseSort = '';
        //this.form.subjectId = '';
        this.form.period = '';
        let projectIdTem = this.form.projectId;
        if (this.vdui.isNotEmpty(projectIdTem)) {

          //周期
          getPeriodList({projectId: this.form.projectId}).then(({data}) => {
            if (this.operateType === 'add') {
              this.form.period = null;
            }
            const column = this.findObject(this.option.column, 'period');
            let arr = [];
            if (this.vdui.isNotEmpty(data)) {
              data.forEach(ele => {
                //ele = dayjs(ele).format('YYYY')
                let obj = {}
                obj.name = ele;
                obj.value = ele;
                arr.push(obj)
              })
              column.dicData = arr;
            } else {
              column.dicData = [{}];
            }
          });

          //科目
          setTimeout(() => {

                  getSubjectBySort({projectId: this.form.projectId}).then(({data}) => {
                    if (this.operateType === 'add') {
                      this.form.subjectId = null;
                    }
                    const column = this.findObject(this.option.column, 'subjectId');
                    column.dicData = data;
                    if (column.dicData.length == 0) {
                      //column.dicData.push([{}]);
                      column.dicData = [{}];
                    }

                  });


              }, 0)


        }

      },
      // 'form.analyseSort'(flag) {
      //
      //   this.form.subjectId = '';
      //   let analyseSortTem = this.form.analyseSort;
      //
      //   setTimeout(() => {
      //     if (this.vdui.isNotEmpty(analyseSortTem)) {
      //       getSubjectBySort({projectId: this.form.projectId, analyseSort: this.form.analyseSort}).then(({data}) => {
      //         if (this.operateType === 'add') {
      //           this.form.subjectId = null;
      //         }
      //         const column = this.findObject(this.option.column, 'subjectId');
      //         column.dicData = data;
      //         if (column.dicData.length == 0) {
      //           //column.dicData.push([{}]);
      //           column.dicData = [{}];
      //         }
      //
      //       });
      //
      //     }
      //   }, 0)
      //
      // },
      'form.period'(){
        if(this.form.flag==='add'){

          this.form.accountingMonth= this.form.period;
        }else if(this.form.flag==='edit'){
          if(this.form.periodFlag===false){
            this.form.periodFlag=true;
            return;
          }else if(this.form.periodFlag===true){

            console.log(dayjs(this.form.period))
            this.form.accountingMonth= this.form.period;

          }
        }
      },


      'form.subjectId'() {

        if (this.form.flag === 'add') {

          let subjectIdTem = this.form.subjectId;
          if (this.vdui.isNotEmpty(subjectIdTem)) {
            getSortBySubject({
              id: this.form.id,
              projectId: this.form.projectId,
              subjectId: this.form.subjectId,
            }).then(({data}) => {
              this.form.analyseSort = data.analyseSort;

            });
          }
        } else if (this.form.flag === 'edit') {
          if (this.form.subjectFlag === false) {
            this.form.subjectFlag = true;
            return;
          } else if (this.form.subjectFlag === true) {
            console.log(1111111111)
            let subjectIdTem = this.form.subjectId;
            if (this.vdui.isNotEmpty(subjectIdTem)) {
              getSortBySubject({
                projectId: this.form.projectId,
                subjectId: this.form.subjectId,
              }).then(({data}) => {
                this.form.analyseSort = data.analyseSort;

              });

            }
          }

          //   }
        // if (this.form.flag === 'add') {
        //   if (this.vdui.isNotEmpty(subjectIdTem)) {
        //     getLastEndTime({
        //       projectId: this.form.projectId,
        //       period: this.form.period,
        //       subjectId: this.form.subjectId,
        //       analyseSort: this.form.analyseSort,
        //     }).then(({data}) => {
        //       if (this.operateType === 'add') {
        //         this.form.subjectId = null;
        //       }
        //       this.form.startTime = data.startTime;
        //     });
        //   }
        }
      },

    },
    created() {
      this.headers['Authorization'] = `Basic ${Base64.encode(
        `${settings.clientId}:${settings.clientSecret}`
      )}`;
      // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      this.headers['Blade-Auth'] = 'bearer ' + getToken();
      //加载列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        this.projectName = this.projectList[0].name;
        this.query.projectId = this.projectList[0].id;
        getPeriodList({projectId: this.query.projectId}).then(res => {
          const column = this.findObject(this.option.column, 'period');
          //column.dicData = res.data;
          console.log(res.data)
          let arr = [];
          if (this.vdui.isNotEmpty(res.data)) {
            res.data.forEach(ele => {
              //ele = dayjs(ele).format('YYYY');
              let obj = {};
              obj.name = ele;
              obj.value = ele;
              arr.push(obj)
            })
            column.dicData = arr;
          } else {
            column.dicData = [""];
          }
        })
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          //this.tempProjectId = this.projectList[0].id;
        }
        const columnSubjectId = this.findObject(this.option.column, 'subjectId');
        if (this.query.projectId) {
          getSubjectBySort({projectId: this.query.projectId}).then(({data}) => {
            if (this.operateType === 'add') {
              this.form.subjectId = null;
            }

            columnSubjectId.dicData = data;
            this.subjectIdList = data;
          });

        } else {
          columnSubjectId.dicData = [{}];
        }
        this.$nextTick(() => {
          this.reWrite = true;
        });
        //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
        //this.firstDisplayFlag = true;
      });

      // getDictionary({code: "vaule_analyse_sort"}).then((res) => {
      //   this.analyseSortList = res.data.data;
      //   console.log(res.data.data);
      //
      // });
    },
    methods: {
      // searchAnalyseSortChange(e) {
      //   this.query.subjectId = '';
      //   this.subjectIdName = '';
      //   this.query.analyseSort = e;
      //   const column = this.findObject(this.option.column, 'subjectId');
      //   if (this.query.projectId && e) {
      //     // 选择类别 所以类别一定存在 只用判断项目是否存在
      //     getSubjectBySort({projectId: this.query.projectId, analyseSort: e}).then(({data}) => {
      //       if (this.operateType === 'add') {
      //         this.form.subjectId = null;
      //       }
      //       const column = this.findObject(this.option.column, 'subjectId');
      //       //column.dicData = data;
      //       this.subjectIdList = data;
      //     });
      //
      //   } else {
      //     column.dicData = [{}];
      //   }
      // },
      searchProjectChange(e) {
        this.query.projectId = e;
        this.query.analyseSort = null;
        this.subjectIdName = '';
        this.analyseSortName = "";
        this.subjectIdList=[{}];
        const column = this.findObject(this.option.column, 'subjectId');

        if (e) {

              getSubjectBySort({projectId: e}).then(({data}) => {
                if (this.operateType === 'add') {
                  this.form.subjectId = null;
                }
                const column = this.findObject(this.option.column, 'subjectId');
                column.dicData = data;
                this.subjectIdList = data;
              });

            } else {
              column.dicData = [{}];
            }

        getPeriodList({projectId: e}).then(res => {
          const column = this.findObject(this.option.column, 'period');
          //column.dicData = res.data;
          console.log(res.data)
          let arr = [];
          if (this.vdui.isNotEmpty(res.data)) {
            res.data.forEach(ele => {
              //ele = dayjs(ele).format('YYYY')
              let obj = {}
              obj.name = ele;
              obj.value = ele;
              arr.push(obj)
            })
            column.dicData = arr;
          } else {
            column.dicData = [""];
          }
        })
      },
      /* getProjectNameById(projectId) {
         let projectName = '';
         this.projectList.forEach(function (value, index, array) {
           if (value.id === projectId) {
             projectName = value.name;
             return;
           }
         });
         return projectName;
       },*/
      rowSave(row, done, loading) {
        console.log(row);
        row.accountingMonth=dayjs(row.accountingMonth).format('YYYY-MM-DD 00:00:00');
        add(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      emptyForm() {
        this.form.id = '';
        this.form.projectId = '';
        this.form.period = '';
        this.form.subjectId = '';
        this.form.analyseSort = '';
        this.form.startTime = '';
        this.form.endTime = '';
        this.form.money = '';
        this.form.attachIds = '';
        this.form.attachList = [];
        this.form.accountingMonth='';
        this.form.fileList=[];

      },
      rowUpdate(row, index, done, loading) {
        row.accountingMonth=dayjs(row.accountingMonth).format('YYYY-MM-DD 00:00:00');
        update(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },

      beforeOpen(done, type) {
        this.form.flag = type;
        this.form.periodFlag=false;
        this.viewFlag = false;
        this.form.subjectFlag=false;
        if (type == "add") {
          this.form.fileList = []
        }
        if (type === 'view') {
          this.viewFlag = true;
        }
        if (["edit", "view"].includes(type)) {

          // getAttachByMainIdList({mainId: this.form.id}).then(({data}) => {
          //   if (data) {
          //     data.forEach(item => {
          //       item.url = item.link;
          //       this.attachIdList.push(item.id);
          //       item.name = item.originalName;
          //     })
          //     this.form.fileList = data;
          //     this.form.attachIds = this.attachIdList.join(',');
          //   }
          // });
          if (["view"].includes(type)) {
            console.log('查看')
            this.fileDisabled = true;
          }
          setTimeout(() => {
            getDetail({id: this.form.id}).then(({data}) => {
              console.log(99999)
              this.form.period = data.period;
              this.form.subjectId = data.subjectId;
              this.form.analyse_sort=data.analyse_sort;
              this.form.subjectName1 = data.subjectName1;
              this.form.fileList=data.fileList;
            });

          }, 0)

        } else {
          setTimeout(() => {
            this.form.projectId = this.query.projectId;
          }, 0)
        }
        ;
        done();
      },
      beforeClose(done, type) {
        this.emptyForm();
        this.attachIdList = [];
        this.form = [];
        this.fileDisabled = false;
        done();
      },

      searchReset() {
        this.query.period = null;
        this.query.analyseSort = null;
        this.analyseSortName = null;
        this.subjectIdName = '';
        this.query.subjectId='';
        const column = this.findObject(this.option.column, 'subjectId');
        column.dicData = [{}];
        //this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {
        console.log(this.query.projectId)
        params.projectId = this.query.projectId;
        params.analyseSort = this.query.analyseSort;

        params.projectName = this.query.projectName;
        //params.analyseSortName = this.query.analyseSortName;
        this.query.period = params.period;
        this.query.subjectId = this.subjectIdName;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区

        if (!this.query.projectId) {
          this.query.projectId = this.query.projectId;
        }
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();

        });
      }
    }
  };
</script>

<style>
</style>
